import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout/PublicLayout/PublicLayout';

import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";




import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import { activities } from './activityData';
import { eventGroups } from './activityData';




const Events = () => {
    const { eventID } = useParams<{ eventID?: string }>();
    const navigate = useNavigate();

    const activity = activities.find(a => a.id === Number(eventID));

    let initialGroupId = eventGroups[0].id;
    if (eventID) {
        const parsedId = parseInt(eventID, 10);
        if (!isNaN(parsedId) && eventGroups.some(g => g.id === parsedId)) {
            initialGroupId = parsedId;
        }
    }

    const [activeGroupId, setActiveGroupId] = useState(initialGroupId);

    const [index, setIndex] = useState(-1);


    useEffect(() => {
        let newGroupId = eventGroups[0].id;
        if (eventID) {
            const parsedId = parseInt(eventID, 10);
            if (!isNaN(parsedId) && eventGroups.some(g => g.id === parsedId)) {
                newGroupId = parsedId;
            }
        }
        setActiveGroupId(newGroupId);
        setIndex(-1);
    }, [eventID]);


    const activeGroup = eventGroups.find(group => group.id === activeGroupId);
    const photos = activeGroup ? activeGroup.photos : [];


    const handleGroupClick = (groupId: number) => {
        navigate(`/Events/${groupId}`);
    };


    const handleCloseLightbox = () => {
        setIndex(-1);
    };

    return (
        <Layout>

            <div className='event-header'>
                <div className='container'>
                    <h2>{activity?.title}
                        <br />
                        <span>{activity?.date}</span>
                    </h2>

                </div>
            </div>

            <div className='event-container'>
                <div className='container'>
                    <div className='event-desc'>
                        <div className='container'>
                            {activity?.desc}
                            <br />
                            <br />


                            <RowsPhotoAlbum
                                photos={photos}
                                targetRowHeight={150}
                                onClick={({ index }) => setIndex(index)}
                            />

                            <Lightbox
                                slides={photos}
                                open={index >= 0}
                                index={index}
                                close={handleCloseLightbox}

                                plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Events;